import { Filters } from '@/app/types'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import React from 'react'
import Button from '@/app/components/common/Button'

interface FilterButtonsProps {
	localValue: Filters
	handleReset: () => void
	applyFilters: () => void
	countActiveFilters: (filters: Filters) => number
}

const FilterButtons: React.FC<FilterButtonsProps> = ({
	localValue,
	handleReset,
	applyFilters,
	countActiveFilters,
}) => {
	const t = useTranslations('Keywords')
	return (
		<div className="hotel-list-filters__mobile-buttons flex gap-2 flex-shrink-0">
			<div className="w-1/2 flex items-center">
				{countActiveFilters(localValue) > 0 && (
					<Button
						onClick={handleReset}
						name={t('clearAll')}
						bgColor="white"
						textColor="main"
						bold
						className="rounded-full py-2 px-0 whitespace-nowrap w-auto !text-base"
					>
						{t('clearAll')}{' '}
						{countActiveFilters(localValue) > 0 &&
							`(${countActiveFilters(localValue)})`}
					</Button>
				)}
			</div>
			<Button
				onClick={applyFilters}
				name={t('showResults')}
				bgColor="main"
				textColor="white"
				bold
				className="bg-text-900 !rounded-full px-6 py-2.5 whitespace-nowrap text-center !text-base leading-3 w-auto"
			>
				{t('showResults')}
			</Button>
		</div>
	)
}

export default FilterButtons
